module.exports = __webpack_public_path__ + "img/icon9.4384ca78.png";